export default __webpack_public_path__ + "static/media/facebook-icon.fa5184c2.svg";